import BaseModelAPI from '../BaseModelAPI';

export default class QcStatusList extends BaseModelAPI {

	static entity = 'qcstatuslist'
	static entityName = 'qcstatus';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
